import * as moment from 'moment-timezone';
moment.locale('es-mx');

export const generalDateFormat = 'DD MMMM YYYY  HH:mm [hrs]';
export const DateFormatWithoutTime = 'DD MMMM YYYY';
export const DateShortMonth = 'DD MMM YYYY';
export const DateLogTime = 'DD MMMM YYYY - hh:mm';
export const DateFormatZone = 'YYYY-MM-DDTHH:mm:ssZ';
export const months = 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
  '_'
);
export const DateWithSlashes = 'DD-MM-YYYY';
export const DateWithSlashesStartingYear = 'YYYY-MM-DD';
export const DateOnlyHours24hrs = 'H:mm';

moment.updateLocale('es', { months });

export function dateUTC(date: string | moment.Moment, format?: string): string {
  const formatDate =
    format === 'MX' ? DateFormatWithoutTime : generalDateFormat;

  return moment(date).locale('es').format(formatDate);
}

export function dateWithoutTime(date: string | moment.Moment): string {
  return moment(date).utc().locale('es').format(DateFormatWithoutTime);
}

export function dateShortMonth(date: string | moment.Moment): string {
  return moment(date).locale('es').format(DateShortMonth);
}

export function dateLogTime(date: string | moment.Moment): string {
  return moment(date).locale('es').format(DateLogTime);
}

export function dateZoneMex(date: string): string {
  return moment(date).tz('America/Mexico_City').format(DateFormatZone);
}

export function compareDateFormatWithoutTime(
  date1: string,
  date2: string
): boolean {
  const parseDate1 = moment(date1).format(DateFormatWithoutTime);
  const parseDate2 = moment(date2).format(DateFormatWithoutTime);
  return parseDate1 === parseDate2;
}

export function convertDateWithSlashes(date?: string): string {
  return moment(date).format(DateWithSlashes);
}

export function convertDateWithSlashesStartingYear(date?: string): string {
  return moment(date).format(DateWithSlashesStartingYear);
}

export function convertDateOnlyHours24hrs(date?: string): string {
  return moment(date).format(DateOnlyHours24hrs);
}

export function converteDateOnlyHours24moment(date: string): moment.Moment {
  return moment(date, DateOnlyHours24hrs);
}
